import { useRouter } from 'vue-router'
import { ORDER_COLUMN, STATE_COLUMN } from '../constant'
import { computed, shallowReactive, ref, createVNode, unref } from 'vue'
import type { ISchema } from '-/Base/BdForm'
import type { IConfig } from '../types'
import { message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { isDef, isFunction } from '@bd/vue3-utils'
export const registerDialogForm = (config: IConfig, updateTable: BD.Fn<any>, emits) => {
  const router = useRouter()
  const state = shallowReactive<{
    visible: boolean
    currentType: 'add' | 'edit'
  }>({
    visible: false,
    currentType: 'add'
  })
  const dialogFormModel = ref()
  const isEdit = computed(() => state.currentType === 'edit')
  /* 弹窗标题 */
  const title = computed(() => `${unref(isEdit) ? config.updateAction?.title ?? '编辑' : config.createAction?.title ?? '新建'}${config.title}`)
  /* 表单schema */
  const schema = computed(() => {
    const _res: ISchema = []
    const _get = list => {
      list.forEach(item => {
        item.form &&
          _res.push({
            dataIndex: item.dataIndex,
            title: item?.title ?? '',
            ...item.form
          })
        item.children?.length && _get(item.children)
      })
    }
    _get(config.columns)
    if (config.enableAction && config.disableAction) {
      _res.push({
        dataIndex: STATE_COLUMN.dataIndex,
        title: STATE_COLUMN.title,
        ...STATE_COLUMN.form
      } as ISchema[0])
    }
    if (config.orderAction) {
      _res.push({
        dataIndex: ORDER_COLUMN.dataIndex,
        title: ORDER_COLUMN.title,
        ...ORDER_COLUMN.form
      } as ISchema[0])
    }
    return _res
  })
  /* 新建处理 */
  const handleAdd = () => {
    const _conf = config.createAction
    if (!isDef(_conf)) return
    if (_conf?.customFn) {
      _conf.customFn()
      return
    }
    if (isDef(_conf?.go)) {
      const { href } = router.resolve(isFunction(_conf.go) ? _conf.go() : _conf.go)
      unref(_conf.isBlank) ? window.open(href, '_blank') : router.push(href)
      return
    }
    dialogFormModel.value = null
    state.currentType = 'add'
    state.visible = true
  }
  /* 编辑处理 */
  //! todo 优化编辑操作
  const handleEdit = async record => {
    const _conf = config.updateAction
    if (!isDef(_conf)) return
    if (_conf?.customFn) {
      _conf.customFn(record)
      return
    }
    if (isDef(_conf?.go)) {
      const { href } = router.resolve(isFunction(_conf.go) ? _conf.go({ record }) : _conf.go)
      unref(_conf.isBlank) ? window.open(href, '_blank') : router.push(href)
      return
    }
    dialogFormModel.value = (await _conf?.beforeInit?.({ record })) ?? record
    state.currentType = 'edit'
    state.visible = true
  }
  /* 删除处理 */
  const handleDel = record => {
    if (config.deleteAction?.customFn) {
      config.deleteAction.customFn(record)
      return
    }
    Modal.confirm({
      title: '重要提示',
      centered: true,
      icon: createVNode(ExclamationCircleOutlined),
      content: `确认${config.deleteAction?.title ?? '删除'}${config.deleteAction?.displayId ? record.id : record.name || ''}?`,
      onOk: async () => {
        const _key = config.deleteAction?.key ?? 'ids'
        const _params = config.deleteAction?.before?.(record) ?? { [_key]: [record[config.deleteAction?.recordKey ?? 'id']] }
        try {
          await config.deleteAction?.fn?.(_params)
          message.success(`${config.deleteAction?.title ?? '删除'}成功`)
          updateTable()
          emits('refresh')
        } catch (err) {
          message.error(`${config.deleteAction?.title ?? '删除'}失败`)
        }
      }
    })
  }
  /* 提交处理 */
  const handleSubmit = async modelRef => {
    try {
      let _params
      if (!unref(isEdit)) {
        _params = config.createAction?.before?.({ modelRef }) ?? modelRef
        await config.createAction?.fn?.(_params)
      } else {
        const _key = config.updateAction?.key ?? 'id'
        _params = config.updateAction?.before?.({ modelRef, record: dialogFormModel.value }) ?? {
          ...modelRef,
          [_key]: dialogFormModel.value[_key]
        }
        await config.updateAction?.fn?.(_params)
      }
      message.success(`${title.value}成功`)
      updateTable()
      emits('refresh')
      state.visible = false
    } catch (err) {
      message.error(`${title.value}失败`)
      throw err
    }
  }
  return {
    state,
    title,
    schema,
    dialogFormModel,
    handleAdd,
    handleEdit,
    handleDel,
    handleSubmit,
    isEdit
  }
}
